<template>
  <div id="memberRegistration">
    <div id="cont_steps">
      <v-row>
        <v-col
          md="12"
          class="text-center mt-5"
          v-if="!age18 || (age18 && step == 1)"
        >
          <img
            src="@/assets/images/VectorLogo.png"
            style="max-width:350px; width: calc(100% - 2rem); margin: 0 1rem;"
            ref="imgTop"
            @error="loadPlaceholder"
          />
          <h1 style="font-weight:300" class="mb0 text-h5 text-sm-h4">
            {{ $t("membershipRegistration.title") }}
          </h1>
        </v-col>
        <v-col
          md="12"
          class="text-center mt-5"
          v-if="itemOrg && age18 && step > 1"
        >
          <ImageCard
            :src="itemOrg.photo"
            :urlImage="itemOrg.photo"
            height="80"
            typeComponent="Single"
            style="max-width:350px"
          />
          <h1 style="font-weight:300" class="mb0">{{ itemOrg.orgName }}</h1>
        </v-col>
      </v-row>
      <div v-if="!errorPage">
      <v-row v-if="age18" no-gutters>
        <v-col md="12" class="py-4">
          <v-tabs v-model="tab" centered>
            <v-tab>{{ $t("memberRegistration.tab1") }}</v-tab>
            <v-tab v-if="isOrganizationSelected">{{ $t("memberRegistration.tab2") }}</v-tab>
            <v-tab v-if="isOrganizationSelected">{{ $t("memberRegistration.tab3") }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-stepper v-model="step" @reload="reloadstep($event)">
                <v-stepper-header>
                  <v-stepper-step
                    :complete="step > 1"
                    step="1"
                    :color="`${buttonColor}`"
                    >{{ $t("memberRegistration.step1.header") }}</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step
                    :complete="step > 2"
                    step="2"
                    :color="`${buttonColor}`"
                    >{{ $t("memberRegistration.step2.header") }}</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step
                    :complete="step > 3"
                    step="3"
                    :color="`${buttonColor}`"
                    >{{ $t("memberRegistration.step3.header") }}</v-stepper-step
                  >
                  <!-- AMA Waiver Bypass v2: dedicated AMA membership step -->
                  <v-divider v-show="requiresValidAma"></v-divider>
                  <v-stepper-step
                    v-show="requiresValidAma"
                    :complete="step > 3.05"
                    step="3.05"
                    :color="`${buttonColor}`"
                    >{{ $t("memberRegistration.ama_step.header") }}</v-stepper-step
                  >
                  <!-- Waiver step is routed AFTER the AMA step so AMA-bypassed
                       waivers are filtered before signing. Renumbered 2.1 →
                       3.06 so the stepper's visual order matches the flow. -->
                  <v-divider v-show="hasWaiversToSign"></v-divider>
                  <v-stepper-step
                    v-show="hasWaiversToSign"
                    :complete="step > 3.06"
                    step="3.06"
                    :color="`${buttonColor}`"
                    >{{ $t("memberRegistration.step_waiver.header") }}</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step
                    :complete="step > 3.1"
                    v-show="isHeadshotRequired"
                    step="3.1"
                    :color="`${buttonColor}`"
                    >{{ $tc("memberRegistration.step_upload_picture.header") }}</v-stepper-step
                  >
                    <v-divider v-show="isHeadshotRequired"></v-divider>
                    <v-stepper-step
                    :complete="step > 3.2"
                    v-show="isTeamRequired"
                    step="3.2"
                    :color="`${buttonColor}`"
                    >{{ $tc("memberRegistration.step_team_selection.header") }}</v-stepper-step>
                    <v-divider v-show="isTeamRequired"></v-divider>
                    <v-stepper-step
                    :complete="step > 3.3"
                    v-show="isRequiredMemberRelation"
                    step="3.3"
                    :color="`${buttonColor}`"
                    >{{ $tc("memberRegistration.step_crew_membership.header") }}</v-stepper-step>
                    <v-divider v-show="isRequiredMemberRelation"></v-divider>
                    <v-stepper-step
                    :complete="step > 4"
                    step="4"
                    :color="`${buttonColor}`"
                      >{{ $t("memberRegistration.step4.header") }}</v-stepper-step>
                  <!-- Start Step 5 Extra Items -->
                  <v-divider v-show="extraItems.length > 0 || extraItemsLength > 0"></v-divider>
                  <v-stepper-step
                    v-show="extraItems.length > 0 || extraItemsLength > 0"
                    :complete="step > 5"
                    step="5"
                    :color="`${buttonColor}`"
                    >{{ $t("memberRegistration.step5_extra_items.header") }}</v-stepper-step
                  >
                  <!-- End Step 5 Group Class -->
                  <v-divider></v-divider>
                  <v-stepper-step
                    :complete="step > 6"
                    step="6"
                    :color="`${buttonColor}`"
                    >{{ $t("memberRegistration.step5.header") }}</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step
                    :complete="step > 7"
                    step="7"
                    :color="`${buttonColor}`"
                    >{{ $t("memberRegistration.step6.header") }}</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step
                    :complete="step == 8"
                    step="8"
                    :color="`${buttonColor}`"
                    >{{ $t("memberRegistration.step7.header") }}</v-stepper-step
                  >
                </v-stepper-header>
                <v-stepper-items>
                  <!-- step organization v-if="!token"-->
                  <v-stepper-content step="1" class="step-xs">
                    <div v-if="showOrgUnavailableAlert" class="mb-4 pa-3 org-unavailable-message">
                      {{ $t("memberRegistration.step1.org_unavailable_message") }}
                    </div>
                    <Step1Organization
                      :searchOrganization="searchOrganization"
                      :orgItemsFiltered="orgItemsFiltered"
                      :windowWidth="windowWidth"
                      :buttonColor="buttonColor"
                      :colorCard="colorCard"
                      @next-step-org="nextStepOrg"
                      @updateSearchOrganization="updateSearchOrganization"
                    />
                  </v-stepper-content>

                  <!-- step participants -->
                  <v-stepper-content step="2" class="step-xs" v-if="!token">
                    <v-col class="pa-0" md="12" v-if="!loadingParts">
                      <v-skeleton-loader
                        v-for="n in 3"
                        :key="n"
                        class="mx-auto"
                        type="list-item-avatar-three-line"
                      ></v-skeleton-loader>
                    </v-col>
                    <Step2Participants
                      v-else
                      :registrationObj="registrationObj"
                      :step="step"
                      :isVehicles="isVehicles"
                      :isSponsors="isSponsors"
                      :itemOrg="itemOrg"
                      :defaultRegistration="defaultRegistration"
                      :orgDefaultId="orgDefaultId"
                      @validateRiders="validateStep"
                      @nextStep="nextStep"
                      :previousStep="previousStep"
                      @showLimitMessage="handleShowLimitMessage"
                    />
                  </v-stepper-content>

                  <v-stepper-content v-if="!token && hasWaiversToSign" step="3.06" class="step-xs">
                    <StepWaivers
                      :step="step"
                      :buttonColor="buttonColor"
                      :selectedParticipants="selectedParticipants"
                      :userId="userId"
                      :urlDomain="urlDomain"
                      :currentIp="currentIp"
                      :membershipType="membershipType"
                      :refreshingWaivers="loadingOrganizationWaivers"
                      :previousStep="requiresValidAma ? 3.05 : 3"
                      :nextStepValue="waiversNextStepValue"
                      :organizationName="itemOrg ? itemOrg.orgName : ''"
                      ref="waivers"
                      @nextStep="nextStep"
                      @getOrganizationWaiverSigned="getOrganizationWaiverSigned"
                    />
                  </v-stepper-content>

                  <!-- step membership type-->
                  <v-stepper-content step="3" class="step-xs" v-if="!token">
                    <Step3MembershipType
                      :step="step"
                      :buttonColor="buttonColor"
                      :membershipTypes="filteredMembershipTypes"
                      :participants="registrationObj.partsSel"
                      :membershipType="membershipType"
                      :itemOrg="itemOrg"
                      @nextStep="onMembershipTypeNextStep"
                      :previousStep="2"
                      @updateDailyEvent="updateDailyEvent"
                      @setSkipClassSelection="setSkipClassSelection"
                      @setMembershipType="setMembershipType"
                      @updateParticipants="updateParticipantsSelectedEvent"
                    />
                  </v-stepper-content>

                  <!-- AMA Waiver Bypass v2: dedicated AMA membership step -->
                  <v-stepper-content v-if="!token && requiresValidAma" step="3.05" class="step-xs">
                    <StepAmaMembership
                      :participants="registrationObj.partsSel"
                      :membershipType="fullMembershipTypeForAma"
                      :itemOrg="itemOrg"
                      :buttonColor="buttonColor"
                      :previousStep="3"
                      :nextStepValue="amaStepNextValue"
                      @nextStep="onAmaStepNext"
                      @ama-state="onAmaState"
                      @add-ama="onAddAma"
                      @ama-mismatch="onAmaMismatch"
                    />
                  </v-stepper-content>

                  <!-- step upload picture -->
                  <v-stepper-content step="3.1" class="step-xs" v-if="!token">
                    <StepUploadPicture
                      :step="step"
                      :buttonColor="buttonColor"
                      :selectedParticipants="registrationObj.partsSel"
                      v-show="isHeadshotRequired"
                      @nextStep="nextStep"
                      :previousStep="3"
                      :nextStepValue="isTeamRequired ? 3.2 : (isRequiredMemberRelation ? 3.3 : 4)"
                    />
                  </v-stepper-content>
                  <!-- step team selection -->
                  <v-stepper-content step="3.2" class="step-xs" v-if="!token">
                    <StepTeamSelection
                      :step="step"
                      :buttonColor="buttonColor"
                      :selectedParticipants="registrationObj.partsSel"
                      :organizationId="organizationId"
                      v-show="isTeamRequired"
                      @nextStep="nextStep"
                      :previousStep="isHeadshotRequired ? 3.1 : 3"
                      :nextStepValue="isRequiredMemberRelation ? 3.3 : 4"
                    />
                  </v-stepper-content>
                  <!-- step crew membership -->
                  <v-stepper-content step="3.3" class="step-xs" v-if="!token">
                    <StepCrewMembership
                      :step="step"
                      :buttonColor="buttonColor"
                      :selectedParticipants="registrationObj.partsSel"
                      :organizationId="organizationId"
                      v-show="isRequiredMemberRelation"
                      @nextStep="nextStep"
                      :previousStep="isTeamRequired ? 3.2 : (isHeadshotRequired ? 3.1 : 3)"
                      :nextStepValue="4"
                      :langCode="langCode"
                    />
                  </v-stepper-content>
                  <!-- step class selection-->
                  <v-stepper-content step="4" class="step-xs" v-if="!token">
                    <Step4ClassSelection
                      :step="step"
                      :buttonColor="buttonColor"
                      :selectedParticipants="selectedParticipants"
                      :participants="registrationObj.participants"
                      :membershipTypeId="membershipTypeId"
                      :organizationId="organizationId"
                      :extraItems="extraItems"
                      @nextStep="nextStep"
                      :previousStep="isRequiredMemberRelation ? 3.3 : (isTeamRequired ? 3.2 : (isHeadshotRequired ? 3.1 : 3))"
                    />
                  </v-stepper-content>
                  <!-- Start Step 5 Extra Items -->
                  <v-stepper-content step="5" class="step-xs" v-if="!token">
                    <Step5ExtraItems
                      :step="step"
                      :buttonColor="buttonColor"
                      :extraItems="extraItems"
                      :registrationObj="registrationObj"
                      @nextStep="nextStep"
                      :previousStep="4"
                    />
                  </v-stepper-content>
                  <!-- End Step 5 Extra Items -->

                  <!-- step Feedback-->
                  <v-stepper-content step="6" class="step-xs" v-if="!token">
                    <Step5Feedback
                      :step="step"
                      :buttonColor="buttonColor"
                      @updateFeedback="updateFeedback"
                      @nextStep="nextStep"
                      :previousStep="extraItems.length > 0 ? 5 : 4"
                      :nextStepValue="7"
                    />
                  </v-stepper-content>

                  <!-- step Step6TransactionSummary-->
                  <v-stepper-content step="7" class="step-xs" v-if="!token">
                    <Step6TransactionSummary
                      :step="step"
                      :buttonColor="buttonColor"
                      :membershipType="membershipType"
                      :itemOrg="itemOrg"
                      :selectedParticipants="selectedParticipants"
                      ref="transactionSummary"
                      @setMembershipCardsStep="setMembershipCardsStep"
                      @cancelRegistration="cancelRegistration"
                      @paypalPayment="paypalPayment"
                    />
                  </v-stepper-content>

                  <!-- step passport -->
                  <v-stepper-content step="8" class="step-xs" v-if="token && step == 8">
                    <StepPassport
                      :step="step"
                      :buttonColor="buttonColor"
                      :registrationCards="passport.registrationCards"
                      :itemOrg="itemOrg"
                      ref="passport"
                    />
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-tab-item>
            <v-tab-item v-if="isOrganizationSelected">
              <v-container>
                <v-row>
                  <v-col cols="12">
                        <v-img
                          :src="itemOrg.photo"
                          height="200px"
                          class="white--text align-end"
                          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                        >
                          <p class="text-h5 font-weight-bold">
                            {{ itemOrg.orgName }}
                          </p>
                        </v-img>
                        <div class="mb-3">
                          <div class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
                            {{ $t("memberRegistration.about_this_organization") }}
                          </div>
                          <p class="body-2" v-html="itemOrg.aboutUs"></p>
                        </div>
                        <v-divider class="my-2"></v-divider>
                        <v-list dense>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary">mdi-credit-card-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{ $t("memberRegistration.payment_via") }} {{ itemOrg.paymentPlatform }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item v-if="itemOrg.allowSignup">
                            <v-list-item-icon>
                              <v-icon color="success">mdi-check-decagram</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{ $t("memberRegistration.open_for_signups") }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                  </v-col>
                </v-row>
              </v-container>              
            </v-tab-item>
            <v-tab-item v-if="isOrganizationSelected">
              <v-row>
                <v-col cols="12">
                  <v-container>
                    <v-expansion-panels flat v-model="panelMembershipTypes">
                        <v-expansion-panel v-for="(mt, index) in membershipTypes" :key="mt.id" :value="index" class="mb-1">
                          <v-expansion-panel-header class="text-customizer-accent white--text" :color="buttonColor">
                            <div class="d-flex justify-space-between">
                              <span>{{ mt.Name }}</span>
                              <span class="text-bold font-weight-bold">{{ formatPrice(mt.price, true) }}</span>
                            </div>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div v-if="mt.periodType == 1">
                              <v-spacer></v-spacer>
                              <v-card-subtitle>
                                <h3>{{ mt.Description }}</h3>
                              </v-card-subtitle>
                              <v-card-subtitle>{{ $t("memberRegistration.prices.membership_valid_for_one_event") }}</v-card-subtitle>
                              <v-card-subtitle v-if="formatMembershipEvents(mt)">
                                {{ $t("memberRegistration.prices.available_events") }} {{ formatMembershipEvents(mt) }}
                              </v-card-subtitle>
                              <div class="pricing-preview-card">
                                <table class="billingDetails membership-pricing-table">
                                  <tr>
                                    <td>{{ $t("memberRegistration.prices.membership_fee_for_date") }}</td>
                                    <td class="orgprice">{{ formatPrice(mt.priceTaxed) }}</td>
                                  </tr>

                                  <tr v-for="tax in mt.taxes" :key="tax.id">
                                    <td>{{ formatMembershipTaxLabel(tax) }}</td>
                                    <td class="orgprice">{{ formatMembershipTaxAmount(tax) }}</td>
                                  </tr>

                                  <tr class="totalline membership-total-row">
                                    <td>
                                      <h3>{{ getMembershipTotalLabel(mt.currency) }}</h3>
                                    </td>
                                    <td class="orgprice">
                                      <h3>{{ formatPrice(mt.price) }}</h3>
                                    </td>
                                  </tr>
                                </table>
                                <p class="membership-pricing-note">*{{ $t("memberRegistration.prices.additional_class_fees_may_apply") }}</p>
                              </div>
                            </div>
                            <div v-else>
                              <v-spacer></v-spacer>
                              <v-card-subtitle>
                                <b>{{ mt.Description }}</b>
                              </v-card-subtitle>
                              <v-card-subtitle class="membership-meta-block pb-0">
                                <p>
                                  <span class="membership-meta-label">{{ $t("memberRegistration.prices.pre_registration_for_existing_members_only") }}</span>
                                  {{ mt.preRegFrom |formatDateForHumans(false) }} {{ $t("memberRegistration.prices.to") }} {{ mt.preRegTo |formatDateForHumans(false) }}
                                </p>
                                <p>
                                  <span class="membership-meta-label">{{ $t("memberRegistration.prices.membership_range") }}</span>
                                  {{ mt.dateFrom |formatDateForHumans(false) }} {{ $t("memberRegistration.prices.to") }} {{ mt.dateTo |formatDateForHumans(false) }}
                                </p>
                              </v-card-subtitle>
                              <v-card-subtitle class="membership-validity-block pt-0">
                                <h2 class="membership-validity-title">
                                  {{ $t("memberRegistration.prices.your_membership_is_only_valid_until") }} 
                                  {{ mt.dateTo |formatDateForHumans(false) }}
                                </h2>
                                <p class="membership-validity-note">
                                  ({{ $t("memberRegistration.prices.it-is-not-valid-for-12-consecutive-months") }} {{ mt.dateTo |formatDateForHumans(false) }})
                                </p>
                              </v-card-subtitle>
                              <div class="pricing-preview-card">
                                <table class="billingDetails membership-pricing-table">
                                  <tr>
                                    <td>{{ $t("memberRegistration.prices.membership_fee_for") }}</td>
                                    <td class="orgprice">{{ formatPrice(mt.priceTaxed) }}</td>
                                  </tr>
                                  <tr v-for="tax in mt.taxes" :key="tax.id">
                                    <td>{{ formatMembershipTaxLabel(tax) }}
                                    </td>
                                    <td class="orgprice" >{{ formatMembershipTaxAmount(tax) }}</td>
                                  </tr>

                                  <tr class="totalline membership-total-row">
                                    <td>
                                      <h3>{{ getMembershipTotalLabel(mt.currency) }}</h3>
                                    </td>
                                    <td class="orgprice">
                                      <h3>{{ formatPrice(mt.price) }}</h3>
                                    </td>
                                  </tr>
                                </table>
                                <p class="membership-pricing-note">*{{ $t("memberRegistration.prices.additional_class_fees_may_apply") }}</p>
                              </div>
                            </div>
                            <div
                              class="mt-2"
                              v-if="showPricesOptionalItems && (getPricesOptionalItems(mt.id).length > 0 || pricesOptionalItemsLoading[mt.id])"
                            >
                              <v-card-subtitle class="pb-1">
                                <h3>{{ $t("memberRegistration.prices.optional_items") }}</h3>
                              </v-card-subtitle>
                              <table class="billingDetails">
                                <tr
                                  v-for="optItem in getPricesOptionalItems(mt.id)"
                                  :key="`opt-${mt.id}-${optItem.id}`"
                                >
                                  <td>{{ optItem.sectionName }} - {{ optItem.optLabel }}</td>
                                  <td class="orgprice">{{ formatPrice(optItem.optCost, true) }}</td>
                                </tr>
                                <tr v-if="pricesOptionalItemsLoading[mt.id]">
                                  <td colspan="2">{{ $t("memberRegistration.prices.loading_optional_items") }}</td>
                                </tr>
                              </table>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                  </v-container>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>          
        </v-col>
      </v-row>
      <v-row no-gutters v-else>
        <v-col md="12" class="pa-3" v-if="loading">
          <WarningAlert>
            <p class="mb-0 font-weight-bold">
              {{ $t("membershipRegistration.content_1") }}
            </p>
            <p class="mb-0">{{ $t("membershipRegistration.content_2") }}</p>
            <p class="mb-0">{{ $t("membershipRegistration.content_3") }}</p>
            <p class="mb-0">{{ $t("membershipRegistration.content_4") }}</p>
          </WarningAlert>
          <WarningProfileMinor></WarningProfileMinor>
          <v-row>
            <v-col>
              <ManagerAccount />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div v-else>
      <v-row>
        <v-col class="px-10">
          <WarningAlert>
            <p style="margin-bottom:0;">
              {{ $t("membershipRegistration.registration_cacelled") }}
            </p>
          </WarningAlert>
        </v-col>
      </v-row>
    </div>
    </div>
    <v-snackbar timeout="6000" v-model="snackbar" :color="color_snackbar" top>
      {{ msg_snackbar }}
    </v-snackbar>
    <v-dialog v-model="showActiveMembershipError" max-width="550" persistent>
      <v-card>
        <v-card-title class="text-h6">
          {{ $t("membershipRegistration.active_membership_title") }}
        </v-card-title>
        <v-card-text>
          <p>{{ $t("membershipRegistration.active_membership_message") }}</p>
          <v-btn
            :color="buttonColor"
            class="btn_next mt-2"
            @click="goToManageClasses"
          >{{ $t("membershipRegistration.go_to_manage_classes") }}</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showActiveMembershipError = false">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AuthService from "../services/AuthService";
import OrganizationService from "../services/OrganizationService";
import GeneralService from "@/services/GeneralService";
import {
  VRow,
  VCol,
  VSnackbar,
  VDivider,
  VStepper,
  VStepperHeader,
  VStepperStep,
  VStepperItems,
  VStepperContent,
  VSkeletonLoader,
  VTabs,
  VTabsItems,
  VTab,
  VTabItem,
  VContainer,
  VExpansionPanels, 
  VExpansionPanel, 
  VExpansionPanelHeader, 
  VExpansionPanelContent,
  VCardSubtitle,
  VSpacer,
  VList,
  VListItem,
  VListItemIcon,
  VListItemContent,
  VListItemTitle,
  VImg, 
  VIcon,
  VDialog,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions
} from "vuetify/lib";
import { mapState, mapGetters } from "vuex";

import RelationshipService from "@/services/RelationshipService";
import LocalStorageService from "@/services/LocalStorageService";
import RegistrationService from "../services/RegistrationService";
import EmergencyContactService from "@/services/EmergencyContactService";
import VehicleService from "../services/VehicleService";
import ManagerAccount from "@/components/authorization/ManagerAccount";
import ImageCard from "@/components/ImageCard";
import WarningProfileMinor from "@/components/alert/WarningProfileMinor";
import Step1Organization from "@/components/memberRegistration/Step1_Organization.vue";
import Step2Participants from "@/components/memberRegistration/Step2_Participants.vue";
import Step3MembershipType from "@/components/memberRegistration/Step3_MembershipType.vue";
import StepAmaMembership from "@/components/memberRegistration/Step_AmaMembership.vue";
import Step4ClassSelection from "@/components/memberRegistration/Step4_ClassSelection.vue";
import Step5Feedback from "@/components/memberRegistration/Step5_Feedback.vue";
import StepWaivers from "@/components/memberRegistration/Step_Waivers.vue";
import Step6TransactionSummary from "@/components/memberRegistration/Step6_TransactionSummary.vue";
import StepPassport from "@/components/memberRegistration/Step_Passport.vue";
import StepUploadPicture from "@/components/memberRegistration/Step_UploadPicture.vue";
import StepTeamSelection from "@/components/memberRegistration/Step_TeamSelection.vue";
import StepCrewMembership from "@/components/memberRegistration/Step_CrewMembership.vue";
import APIService from "@/services/APIService";
import WarningAlert from "@/components/alert/WarningAlert";
import Step5ExtraItems from "@/components/memberRegistration/Step5_ExtraItems.vue";
import axios from "axios";
export default {
  name: "MembershipRegistration",
  components: {
    VRow,
    VCol,
    VSnackbar,
    VDivider,
    VStepper,
    VStepperHeader,
    VStepperStep,
    VStepperItems,
    VStepperContent,
    ManagerAccount,
    VSkeletonLoader,
    ImageCard,
    WarningProfileMinor,
    WarningAlert,
    StepUploadPicture,
    StepTeamSelection,
    StepCrewMembership,
    Step1Organization,
    Step2Participants,
    Step3MembershipType,
    StepAmaMembership,
    Step4ClassSelection,
    Step5Feedback,
    StepWaivers,
    Step6TransactionSummary,
    StepPassport,
    Step5ExtraItems,
    VTabs,
    VTabsItems,
    VTab,
    VTabItem,
    VContainer,
    VExpansionPanels, 
    VExpansionPanel, 
    VExpansionPanelHeader, 
    VExpansionPanelContent,
    VCardSubtitle,
    VSpacer,
    VList,
    VListItem,
    VListItemIcon,
    VListItemContent,
    VListItemTitle,
    VImg,
    VIcon,
    VDialog,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions
  },
  data() {
    return {
      dynamicMenuItems: [],
      buttonColor: "rgb(49, 175, 212)",
      headerColor: "#000",
      manImage: require("@/assets/images/partPlaceholder.jpg"), //change by silhouette man
      womanImage: require("@/assets/images/partPlaceholder.jpg"), //change by silhouette woman,
      defaultImage: require("@/assets/images/partPlaceholder.jpg"),
      step: 1,
      color_snackbar: "",
      snackbar: false,
      msg_snackbar: "",
      searchOrganization: "",
      organizations: [],
      windowWidth: window.innerWidth,
      itemOrg: null,
      windowHeight: 0,
      onLoad: false,
      inProcess: false,
      registrationObj: {
        participants: [],
        extraItems: []
      },
      userId: 0,
      isVehicles: false,
      isSponsors: false,
      orgId: null,
      bPreselectedOrganization: false,
      preselectedOrganizationId: null,
      birthdayCurrent: null,
      loading: false,
      loadLang: false,
      loadingPart: {
        getUser: false,
        getUserRol: false,
        showMembers: false,
        validationUser: false,
        verifyStatus: false,
        getEmergencyContact: false,
        getVehicle: false,
      },
      heightContent: "0px",
      membershipTypes: [],
      dailyEvent: null,
      membershipType: null,
      skipClassSelection: false,
      feedback: "",
      token: null,
      errorPage: false,
      currentIp: "",
      numWaiversToSign: 0,
      hasWaiversToSign: false,
      organizationWaivers: [],
      loadingOrganizationWaivers: false,
      errors: [],
      passport: {
        registrationCards: [],
      },
      passportLoading: false,
      extraItems: [],
      isHeadshotRequired: false,
      isTeamRequired: false,
      isRequiredMemberRelation: false,
      previousStep: 0,
      forceStep: false,
      tab: 0,
      selectedOrganization: null,
      panelMembershipTypes: 0,
      showPricesOptionalItems: false,
      pricesOptionalItemsByMembership: {},
      pricesOptionalItemsLoading: {},
      showActiveMembershipError: false,
      showOrgUnavailableAlert: false,
      amaState: { verifications: {}, mismatches: {}, allValid: false }
    };
  },
  mounted() {
    this.initStep();
    if (this.token && this.step === 8) {
      this.getRegistrationCards();
    }
  },
  computed: {
    ...mapState({
      user: (state) => state,
      language(state) {
        return {
          languageId: state.session.languageId,
          languageCode: state.session.languageCode,
        };
      },
      orgDefaultId: (state) => state.env.get("VUE_APP_DEFAULT_ORGANIZATION"),
      defaultRegistration: (state) =>
        state.env.get("VUE_APP_DEFAULT_REGISTRATION"),
      urlDomain: (state) => state.env.get("VUE_APP_ROOT"),
      colorCard: (state) => state.env.get("VUE_APP_COLOR_CARD"),
      ruta(state) {
        return (
          state.env.get("VUE_APP_ROOT") +
          "/admin/joinclub?" +
          this.itemOrg.id +
          "&disTopMenu=true"
        );
      },
    }),
    ...mapGetters({
      vueAppRoot: "vueAppRoot",
    }),
    /**
     * Main organizations filter, 
     * we should apply here all the filters logic to hide some organizations from default
     */
    filteredOrganizations()
    {
      if(this.preselectedOrganizationId)
      {
        /**
         * An organization was parsed as Route Param
         * Other organizations will be hidden
         */
        return this.organizations.filter(o => o.allowSignup == 1 && o.id == this.preselectedOrganizationId);
      }
      else
      {
        return this.organizations.filter(o => o.allowSignup == 1);
      }
    },
    /**
     * orgItemsFiltered, its used for search functionality, 
     * i will update it to get a list of previous filtered organizations
     */
    orgItemsFiltered() {
      let _results = [];
      if (this.searchOrganization && this.searchOrganization != "") {
        _results = this.filteredOrganizations.filter((org) => {
          return org.orgName
            .toLowerCase()
            .includes(this.searchOrganization.toLowerCase());
        });
      } else {
        _results = this.filteredOrganizations;
      }

      return _results;
    },
    age18() {
      const nowDay = new Date();
      nowDay.setFullYear(nowDay.getFullYear() - 18);
      if (this.birthdayCurrent) {
        const birthday = new Date(this.birthdayCurrent);
        return birthday <= nowDay;
      }
      return false;
    },
    loadingParts() {
      return (
        this.loadingPart.getUser &&
        this.loadingPart.getUserRol &&
        this.loadingPart.showMembers &&
        this.loadingPart.validationUser &&
        this.loadingPart.verifyStatus &&
        this.loadingPart.getEmergencyContact &&
        this.loadingPart.getVehicle /* && this.loadingPart.getSponsors*/
      );
    },
    filteredMembershipTypes() {
      return this.membershipTypes;
    },
    organizationId() {
      return this.itemOrg ? this.itemOrg.id : 0;
    },
    selectedParticipants() {
      const parts = this.registrationObj.participants.filter((el) => {
        return el.selected;
      });
      return parts;
    },
    extraItemsLength() {
      const memberReg = LocalStorageService.getItem("member_reg");
      return memberReg && memberReg.extraItems ? memberReg.extraItems.length : 0;
    },
    selectedParticipantsId() {
      return this.selectedParticipants.map((p) => {
        return p.userId;
      })
    },
    langCode() {
        let code;
        switch (this.$i18n.locale) {
          case "fr":
            code = 2;
            break;

          case "es":
            code = 3;
            break;

          default:
            code = 1;
            break;
        }
        return code;
    },
    membershipTypeId() {
      return this.membershipType ? this.membershipType.id : 0;
    },
    dailyEventId ()
    {
      return this.dailyEvent && this.dailyEvent.id ? this.dailyEvent.id : null;
    },  
    isOrganizationSelected(){
      return this.step && this.step > 1 && this.itemOrg && this.itemOrg.id && this.itemOrg.id > 0 ? true : false;
    },
    /**
     * AMA Waiver Bypass v2: waiver step (3.06, renumbered from 2.1) runs
     * AFTER the AMA step so AMA-bypassed waivers are filtered first. The
     * 'next' target depends on the current post-type flow flags (picture,
     * team, crew) exactly the way Step3MembershipType.stepNext does.
     */
    waiversNextStepValue() {
      if (this.isHeadshotRequired) return 3.1;
      if (this.isTeamRequired) return 3.2;
      if (this.isRequiredMemberRelation) return 3.3;
      if (this.skipClassSelection === 1) return 5;
      return 4;
    },
    /**
     * AMA Waiver Bypass v2: true when the chosen membership type opts
     * into the dedicated AMA step ("Requires valid AMA membership").
     * Drives visibility of the step 3.05 header + content.
     */
    requiresValidAma() {
      return !!(this.membershipType && Number(this.membershipType.requiresValidAma) === 1);
    },
    /**
     * The full membership-type object passed to the AMA step. The
     * membership type in `this.membershipType` already comes from
     * filteredMembershipTypes which is a full row — just pass it.
     */
    fullMembershipTypeForAma() {
      return this.membershipType || null;
    },
    /**
     * Fallback target when the AMA step has no waivers left to show.
     * Mirrors the old waiversNextStepValue path.
     */
    amaStepNextValue() {
      return this.waiversNextStepValue;
    }
  },
  beforeMount()
  {
    const { status, token } = this.$route.params;
    if (token && status == 'registered') {
      this.token = token;
      this.step = 8;
    } else {
      // If registration success is not confirmed, reset for safety
      this.token = null;
      localStorage.removeItem('member_reg'); 
      this.step = 1;
    }
  },
  created() {
    if (this.$store.getters.env.get("VUE_APP_HIDE_MEMBERSHIP_REG") == 1)
      this.$router.push({ name: "Dashboard" });

    this.buttonColor = this.$store.getters.env.get("VUE_APP_BUTTON_COLOR");
    this.headerColor = this.$store.getters.env.get("VUE_APP_HEADER_COLOR");
    this.borderAlertColor = this.$store.getters.env.get(
      "VUE_APP_BORDER_ALERT_REGULAR"
    );
    this.iconAlertColor = this.$store.getters.env.get(
      "VUE_APP_ICON_ALERT_REGULAR"
    );
    this.bgAlertColor = this.$store.getters.env.get("VUE_APP_BG_ALERT_REGULAR");
    
    this.preselectedOrganizationId = this.$route.params.orgId || null;
    if (this.preselectedOrganizationId) {
      this.bPreselectedOrganization = true;
      LocalStorageService.removeItem("link_member_reg");
    }
  },
  methods: {
    formatPrice(value, freeWhenZero = false) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      const numericValue = Number(value);
      if (Number.isFinite(numericValue)) {
        if (numericValue === 0) {
          return freeWhenZero ? this.$t("registerEvent.membership_free") : "0";
        }
        const rawValue = typeof value === "string" ? value.trim() : numericValue.toString();
        return `${this.$t("common.currency.left")}${rawValue}${this.$t("common.currency.right")}`;
      }

      const rawValue = String(value).trim();
      return rawValue
        ? `${this.$t("common.currency.left")}${rawValue}${this.$t("common.currency.right")}`
        : "";
    },
    formatMembershipEvents(membershipType) {
      if (!membershipType || !Array.isArray(membershipType.events)) {
        return "";
      }

      return membershipType.events
        .map((event) => event.eventName)
        .filter(Boolean)
        .join(", ");
    },
    formatMembershipTaxLabel(tax) {
      if (!tax) {
        return "";
      }

      const label = (tax.taxLabel || "").trim();
      const number = tax.taxNumber ? ` (${tax.taxNumber})` : "";
      const source = String(tax.source || "").toLowerCase();
      const isIncluded = source === "included";
      const sign = isIncluded ? "=" : "+";
      return `${sign} ${label}${number}`;
    },
    getMembershipTotalLabel(currencyCode) {
      const code = String(currencyCode || "USD").toUpperCase();
      return this.$t("memberRegistration.prices.membership_total", { currency: code });
    },
    formatMembershipTaxAmount(tax) {
      if (!tax) {
        return "";
      }

      const amount = this.formatPrice(tax.taxAmount);
      const source = String(tax.source || "").toLowerCase();
      const includedSuffix =
        source === "included"
          ? ` ${this.$t("memberRegistration.prices.included_suffix")}`
          : "";
      return `${amount}${includedSuffix}`;
    },
    getPricesOptionalItems(membershipTypeId) {
      return this.pricesOptionalItemsByMembership[membershipTypeId] || [];
    },
    resetOrganizationWaiverState() {
      this.numWaiversToSign = 0;
      this.hasWaiversToSign = false;
      this.organizationWaivers = [];
      this.loadingOrganizationWaivers = false;
    },
    isOrganizationWaiverPending(waiver) {
      if (!waiver) {
        return false;
      }
      const signaturesRequired = Number(waiver.signaturesRequired || 1);
      if (signaturesRequired > 1) {
        return waiver.allSignaturesComplete !== true;
      }
      return waiver.waiverStatus !== "Signed";
    },
    async syncOrganizationWaiversStep() {
      for (let i = 0; i < 10; i++) {
        await this.$nextTick();
        if (this.$refs.waivers && typeof this.$refs.waivers.Initialize === "function") {
          this.$refs.waivers.Initialize(this.organizationWaivers, this.organizationId);
          return;
        }
        if (i < 9) {
          await new Promise(r => setTimeout(r, 50));
        }
      }
    },
    loadPricesOptionalItemsForPanel(panelValue) {
      let panelIndex = panelValue;
      if (Array.isArray(panelValue)) {
        panelIndex = panelValue.length ? panelValue[0] : null;
      }

      const index = Number(panelIndex);
      if (!Number.isInteger(index) || !this.membershipTypes[index]) {
        return;
      }

      this.loadPricesOptionalItems(this.membershipTypes[index].id);
    },
    async loadPricesOptionalItemsForAllMembershipTypes() {
      if (!Array.isArray(this.membershipTypes) || this.membershipTypes.length === 0) {
        return;
      }

      await Promise.all(
        this.membershipTypes.map((membershipType) =>
          this.loadPricesOptionalItems(membershipType.id)
        )
      );
    },
    async loadPricesOptionalItems(membershipTypeId) {
      if (!this.itemOrg || !membershipTypeId) {
        return;
      }

      if (Array.isArray(this.pricesOptionalItemsByMembership[membershipTypeId])) {
        return;
      }

      this.$set(this.pricesOptionalItemsLoading, membershipTypeId, true);

      try {
        const response = await APIService.fetch({
          path: `${this.urlDomain}/laravel/public/api/v1/participant/organization/opt-sections/${this.itemOrg.id}/${membershipTypeId}`,
        });

        let optionalItems = [];
        if (response.data.success && Array.isArray(response.data.message)) {
          optionalItems = response.data.message.flatMap((section) => {
            if (!Array.isArray(section.items)) {
              return [];
            }

            return section.items.map((item) => ({
              ...item,
              sectionName: section.sectionName || "",
            }));
          });
        }

        this.$set(this.pricesOptionalItemsByMembership, membershipTypeId, optionalItems);
      } catch (error) {
        this.$set(this.pricesOptionalItemsByMembership, membershipTypeId, []);
      } finally {
        this.$set(this.pricesOptionalItemsLoading, membershipTypeId, false);
      }
    },
    initStep(){
      this.getIP();
      this.$nextTick(() => {
        window.addEventListener("resize", this.onResize);
      });
      this.windowHeight = window.innerHeight;
      this.initializeUser();
      this.step = this.stepToGo();
      
      if(this.itemOrg && !this.token) {
        const orgDefault = this.$store.getters.env.get('VUE_APP_DEFAULT_ORGANIZATION');
        const hasMultipleDefaultOrgs = Array.isArray(orgDefault) && orgDefault.length > 1;
        if(hasMultipleDefaultOrgs) {
          this.itemOrg = null;
          this.step = 1;
        } else {
          this.nextStepOrg(this.itemOrg);
        }
        if(LocalStorageService.getItem("member_reg")) {
          let _local = LocalStorageService.getItem("member_reg");
          this.registrationObj.participants = _local.participants;
        }
      }
    },
    refresStep()
    {
      this.$emit("changeLoadingStep", true);
      LocalStorageService.removeItem("member_reg");
      this.token = null;
      this.itemOrg = null;
      this.resetOrganizationWaiverState();
      this.step = 1;
      this.$nextTick(() => {
        this.initStep();
      });
    },
    stepToGo() {
        const memberReg = LocalStorageService.getItem("member_reg");

        if (!memberReg) {
            return this.step;
        }

        const { step: stepToReturn = this.step, organization } = memberReg;

        if (memberReg.step) {
            delete memberReg.step;
        }
        
        this.itemOrg = organization || null;

        LocalStorageService.setItem("member_reg", memberReg);
        
        return stepToReturn;
    },
    stepToGo2(){
      let _local = LocalStorageService.getItem("member_reg");
      if(!_local) return this.step;

      let stepToReturn = _local && _local.step ? _local.step : this.step;
      if(_local.step) delete _local.step;

      this.itemOrg = _local && _local.organization ? _local.organization : null;
      
      LocalStorageService.setItem("member_reg", _local);

      return stepToReturn; 
    },
    async initializeUser(){
      try {
        const userResponse = await AuthService.getUserCurrent();
        if (userResponse.data.success === 1) {
          const { firstName, lastName, id, birthday, image } = userResponse.data.message;
          const userName = `${firstName} ${lastName}`;
          
          this.$store.state.session.userid = id;
          this.$store.state.session.username = userName;
          this.$store.state.session.userimage = image;
          this.userId = id;
          this.birthdayCurrent = birthday;
          this.loading = true;

          this.$emit("userName", userName);
        }
        if (this.$route.query.orgId) {
          LocalStorageService.removeItem("link_member_reg");
        }
        const orgDefaultId = this.orgDefaultId;
        const hasDefaultIds = Array.isArray(orgDefaultId) && orgDefaultId.length > 0;

        const orgResponse = hasDefaultIds
          ? await OrganizationService.getOrganizationsByIds(orgDefaultId.join(','))
          : await OrganizationService.getOrganizations();

        if (orgResponse.data.success === 1) {
          this.organizations = orgResponse.data.message;

          if (hasDefaultIds && orgResponse.data.message.length < orgDefaultId.length) {
            this.showOrgUnavailableAlert = true;
          }

          if (this.$route.query.orgId) {
            const queryOrgId = this.$route.query.orgId;
            const queryOrg = this.organizations.filter(el => el.id == queryOrgId);
            if (queryOrg.length > 0) {
              this.organizations = queryOrg;
            }
          }

          // /memberRegistration/:orgId — if the preselected org isn't in the
          // list we just fetched (e.g. VUE_APP_DEFAULT_ORGANIZATION filtered it
          // out), fetch it explicitly so filteredOrganizations can match it.
          // Without this, the filteredOrganizations watcher keeps returning []
          // and nextStepOrg is never called → page hangs on the top spinner.
          if (this.preselectedOrganizationId) {
            const alreadyLoaded = this.organizations.some(
              o => String(o.id) === String(this.preselectedOrganizationId)
            );
            if (!alreadyLoaded) {
              try {
                const preResp = await OrganizationService.getOrganizationsByIds(
                  this.preselectedOrganizationId
                );
                if (
                  preResp &&
                  preResp.data &&
                  preResp.data.success === 1 &&
                  Array.isArray(preResp.data.message) &&
                  preResp.data.message.length > 0
                ) {
                  this.organizations = [
                    ...this.organizations,
                    ...preResp.data.message,
                  ];
                }
              } catch (e) {
                // Best-effort; filteredOrganizations watcher will just
                // remain empty and the user can still pick from whatever
                // loaded. Surfacing the error would block the page.
              }
            }
          }

          if (this.organizations.length === 0) {
            const localOrg = LocalStorageService.getItem("org_reg");
            if (localOrg) {
              const restored = orgResponse.data.message.filter(el => el.id == localOrg.id);
              if (restored.length > 0) {
                this.organizations = restored;
              }
              LocalStorageService.removeItem("org_reg");
            }
          }

          if (this.organizations.length === 1) {
            this.nextStepOrg(this.organizations[0]);
          }
        }
      } catch (error) {
        this.errors.push(error);
      } finally {
        this.$emit("changeLoadingStep", false);
      }
    },
    updateSearchOrganization(search)
    {
      this.searchOrganization = search;
    },
    getIP() {
          fetch(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/users/current/currentIp`)
          .then(x => x.json())
          .then(({ message }) => {
              this.currentIp = message;
          });
      },
    async getMembershipTypes() {
      await APIService.fetch({
        path: `${this.urlDomain}/laravel/public/api/v1/participant/organization/${this.itemOrg.id}/available-membership-type`,
      }).then((resp) => {
        if (resp.data.success) {
          const message = resp.data.message;
          this.pricesOptionalItemsByMembership = {};
          this.pricesOptionalItemsLoading = {};
          this.membershipTypes = message.mebershipTypes;
          this.loadPricesOptionalItemsForAllMembershipTypes();
        }
      });
    },
    async getExtraItems() {
      await APIService.fetch({
        path: `${this.urlDomain}/laravel/public/api/v1/participant/organization/opt-sections/${this.itemOrg.id}/${this.membershipType.id}`,
      }).then((resp) => {
        if (resp.data.success) {
          this.extraItems = resp.data.message;
          this.registrationObj.extraItems = resp.data.message;
        }
      });
    },
    errorImageEvent() {
      this.imageUser = this.$store.getters.env.get("VUE_APP_IMAGE_PLACEHOLDER");
    },
    loadPlaceholder(e) {
      e.target.src = this.$store.getters.env.get("VUE_APP_IMAGE_PLACEHOLDER");
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      if (window.innerWidth > 600) {
        this.textareaRows = 2;
      }
    },
    loadImage(url) {
      const urlImage = GeneralService.cleanImage(
        url,
        this.$store.getters.env.get("VUE_APP_IMAGE_PLACEHOLDER")
      );
      return urlImage;
    },
    async getOrganizationDescription() {
      await APIService.fetch({
        path: `${this.urlDomain}/laravel/public/api/v1/livelaps/organization/${this.itemOrg.id}`,
      }).then((resp) => {
        if (resp.data.success) {
          this.selectedOrganization = resp.data.message;
        }
      });
    },
    nextStepOrg(item) {
      this.forceStep = false;
      this.itemOrg = item;
      this.resetOrganizationWaiverState();

      this.isVehicles = item.showVehiclesInSignup == 2;
      //this.isSponsors = item.showSponsorsInSignup == 2;
      this.loadingPart = {
        getUser: false,
        getUserRol: false,
        showMembers: false,
        validationUser: false,
        verifyStatus: false,
        getEmergencyContact: false,
        getVehicle: false,
        //getSponsors: false
      };

      this.getOrganizationDescription();
      this.getMembershipTypes();
      this.addParticipants();

      this.step = 2;
      var elem2 = document.getElementById("scrolling-techniques-7");
      elem2.scrollTop = 0;
    },
    async validateStep() {
      let selectParticipants = this.registrationObj.participants.filter(
        (el) => {
          return el.selected;
        }
      );
      if (selectParticipants.length > 0) {
        let error = false;
        const membershipParts = selectParticipants.filter((el) => {
          return el.hasMembership;
        });
        if (membershipParts.length > 0) {
          this.showActiveMembershipError = true;
          return;
        }
        const emergencyContactParts = selectParticipants.filter((el) => {
          return !el.emergencyContact;
        });
        if (emergencyContactParts.length > 0)
          error = this.$t("riders.emergency_contact_missing");
        if (!error && this.isVehicles) {
          const vehicleParts = selectParticipants.filter((el) => {
            return el.vehicle != "";
          });
          if (vehicleParts.length > 0) {
            error = this.$t("membershipRegistration.vehicle_required");
          }
        }
        if (!error) {
          this.registrationObj.organization = this.itemOrg;
          this.registrationObj.partsSel = selectParticipants;
          LocalStorageService.setItem("member_reg", this.registrationObj);
          const data = {
            userId: this.user.session.userid,
            orgId: this.itemOrg.id,
            registration: {
              partsSel: this.registrationObj.partsSel,
            },
          };
          try {
            const resp = await RegistrationService.createOrganizationRegistrant(data);
            if (resp.data.success) {
              this.inProcess = true;
              // AMA Waiver Bypass v2: flow is now
              // Participants -> MembershipType -> (re)Waivers -> remaining.
              // Only load membership types here; waivers are fetched after
              // membership type selection so AMA bypass can filter them.
              await this.getMembershipTypes();
              this.nextStep(3);
            } else {
              this.color_snackbar = "error";
              if (resp.data.message == "no_membership_types") {
                this.msg_snackbar = this.$t(
                  "membershipRegistration.no_membership_types"
                );
              } else {
                this.msg_snackbar = this.$t(
                  "membershipRegistration.failed_save"
                );
              }
              this.snackbar = true;
            }
          } catch (error) {
            this.color_snackbar = "error";
            this.msg_snackbar = this.$t("membershipRegistration.failed_save");
            this.snackbar = true;
          }
        } else {
          this.color_snackbar = "error";
          this.msg_snackbar = error;
          this.snackbar = true;
        }
      } else {
        this.color_snackbar = "error";
        this.msg_snackbar = this.$t("registerEvent.empty_participants");
        this.snackbar = true;
      }
    },
    handleShowLimitMessage({ msg, color }) {
      this.showSnackBar(msg, color);
    },
    addRider() {
      this.$router.push({
        path: "ridersCreate",
      });
    },
    nextStep(value) {
      this.previousStep = this.step;

      this.step = value;

    },
    /**
     * AMA Waiver Bypass v2: after the user picks a membership type, refetch
     * the organization waivers so any AMA-bypassed docs are excluded, and
     * route to the waiver step only if any waivers remain. Otherwise jump
     * straight to the next real step (picture/team/crew/payment).
     */
    async onMembershipTypeNextStep(value) {
      // Back navigation (target step is before Membership step 3): go
      // directly instead of force-routing forward through AMA/waivers.
      if (Number(value) < 3) {
        this.nextStep(value);
        return;
      }
      // AMA Waiver Bypass v2: if the chosen membership type requires a
      // valid AMA membership, route through the dedicated AMA step first.
      // Otherwise, fall back to the normal flow (refetch waivers, skip
      // or show the waiver step).
      if (this.requiresValidAma) {
        this.nextStep(3.05);
        return;
      }
      try {
        await this.getOrganizationWaiverSigned();
      } catch (_) {
        // Non-fatal; fall through to the standard routing.
      }
      if (this.hasWaiversToSign) {
        this.nextStep(3.06);
        return;
      }
      this.nextStep(value);
    },
    /**
     * AMA Waiver Bypass v2: after the dedicated AMA step confirms every
     * participant has a valid AMA membership, refetch the waiver list
     * (so AMA-bypassed docs are correctly tagged), then route into the
     * waiver step if anything remains, or jump to the next real step.
     */
    async onAmaStepNext(value) {
      // Back navigation (target step is before AMA): go directly, don't
      // route the user through the waiver step as a side effect.
      if (Number(value) < 3.05) {
        this.nextStep(value);
        return;
      }
      try {
        await this.getOrganizationWaiverSigned();
      } catch (_) {
        // Non-fatal; fall through to the standard routing.
      }
      if (this.hasWaiversToSign) {
        this.nextStep(3.06);
        return;
      }
      this.nextStep(value);
    },
    onAmaState(state) {
      this.amaState = state || { verifications: {}, mismatches: {}, allValid: false };
    },
    onAddAma(/* participant */) {
      // AMA Waiver Bypass v2: adding an AMA number is handled inline by
      // the dedicated AMA step's AddAmaDialog. This stub keeps the emit
      // chain stable; no routing away from the registration flow.
    },
    onAmaMismatch(payload) {
      // eslint-disable-next-line no-console
      console.warn("[memberRegistration] AMA mismatch", payload);
    },
    paypalPayment(regId)
    {
      const baseUrl = `${this.urlDomain}/laravel/public/api/v1/livelaps/`;
      let paymentPath = `organizationRegistrationPayment/${regId}`; 

      if (this.itemOrg.paymentPlatform) {
          const platform = this.itemOrg.paymentPlatform.toLowerCase();
          
          if (platform === 'stripe') {
              paymentPath = `stripe/organizationRegistrationPayment/${regId}`;
          }
      }

      window.top.location.href = baseUrl + paymentPath;
    },
    setMembershipCardsStep(token)
    {
      window.top.location.href = `${this.urlDomain}/laravel/public/api/v1/participant/membership/member-registration/registration-cards-page/${token}`
    },    
    async cancelRegistration(token)
    {
      if (token) {
        try {
          await axios.get(`${this.urlDomain}/laravel/public/api/v1/participant/membership/member-registration/cancel/${encodeURIComponent(token)}/1`);
        } catch (error) {
          // Keep the existing cancel UX even if the legacy redirect response is not JSON.
          // eslint-disable-next-line no-console
          console.warn("[memberRegistration] cancel membership request failed", error);
        }
      }
      this.$router.push({ name: "canceled_membership" });
    },
    goToManageClasses() {
      this.showActiveMembershipError = false;
      const membershipPart = this.registrationObj.participants.find(p => p.selected && p.hasMembership);
      this.$router.push({
        name: "MembershipClasses",
        query: {
          userId: membershipPart ? membershipPart.userId : undefined,
          organizationId: this.itemOrg ? this.itemOrg.id : undefined
        }
      });
    },
    updateDailyEvent(event)
    {
      this.dailyEvent = event;
    },
    setSkipClassSelection(value) {
      this.skipClassSelection = value;
    },
    setMembershipType(value) {
      this.membershipType = value;
      this.isHeadshotRequired = value.isHeadshotRequired;
      this.isTeamRequired = !!value.isTeamRequired;
      this.isRequiredMemberRelation = !!value.isRequiredMemberRelation;
      this.getExtraItems();
    },
    updateParticipantsSelectedEvent(updatedParticipants) {
      // Update participants in partsSel with membershipEventId changes
      if (this.registrationObj.partsSel && updatedParticipants) {
        updatedParticipants.forEach(updatedParticipant => {
          [this.registrationObj.partsSel, this.registrationObj.participants].forEach(participants => {
            if (!participants) {
              return;
            }
            const participant = participants.find(
              p => p.userId === updatedParticipant.userId
            );
            if (participant) {
              participant.membershipEventId = updatedParticipant.membershipEventId;
            }
          });
        });
        // Keep localStorage in sync
        LocalStorageService.setItem("member_reg", this.registrationObj);
      }
    },
    updateFeedback(value) {
      this.feedback = value;
    },
    async addParticipants(cachedUser) {
      var _riders = [];
      var _part_add_news = [];
      this.registrationObj.participants = [];

      // Tier 1: Get current user + user roles in parallel
      var userResp = cachedUser || null;
      var userRoleId = 0;
      var userRoleIdFamily = 0;
      var rolesResp;

      if (!userResp) {
        var responses = await Promise.all([
          AuthService.getUserCurrent(),
          RelationshipService.getUserRoles()
        ]);
        userResp = responses[0].data.success ? responses[0].data.message : null;
        rolesResp = responses[1];
      } else {
        rolesResp = await RelationshipService.getUserRoles();
      }

      if (userResp) {
        this.userId = userResp.id;
        var userFind = this.registrationObj.participants.find(function(el) {
          return el.userId == userResp.id;
        });
        if (!userFind) {
          this.registrationObj.participants.push({
            selected: false,
            disabled: false,
            disabledLimit: false,
            userId: userResp.id,
            lName: userResp.lastName,
            fName: userResp.firstName,
            image: this.defaultImage,
            imagenUrl: '',
            relationship: this.$t("relationship.you"),
            status: "",
            membership: "",
            membershipColor: false,
            waivers: "",
            waiversColor: false,
            classes: "",
            classesColor: false,
            backg: "",
            emergencyContact: "",
            vehicle: "",
            vehicleColor: false,
            sponsor: "",
            sponsorColor: false,
            birthday: userResp.birthday,
            email: userResp.email,
            gender: userResp.gender
          });
        }
      }
      this.loadingPart.getUser = true;

      if (rolesResp.data && rolesResp.data.success == 1) {
        rolesResp.data.message.forEach(function(x) {
          if (x.userRoleCode === "Participant") {
            userRoleId = x.id;
          }
          if (x.userRoleCode === "Spectator") {
            userRoleIdFamily = x.id;
          }
        });
      }
      this.loadingPart.getUserRol = true;

      // Tier 2: Fetch linked members for both roles in parallel
      var linkedResults = await Promise.all([
        RelationshipService.showLinkedMembers(userRoleId),
        RelationshipService.showLinkedMembers(userRoleIdFamily)
      ]);

      if (linkedResults[0].data.success == 1) {
        _riders = linkedResults[0].data.message;
      }
      if (linkedResults[1].data.success == 1) {
        linkedResults[1].data.message.forEach(function(x) {
          _riders.push(x);
        });
      }
      this.loadingPart.showMembers = true;

      // Merge riders into participants
      var _backg = "";
      this.registrationObj.participants = this.registrationObj.participants.filter(
        function(part) {
          if (part.userId == this.userId) return true;
          var partAux = _riders.find(function(x) {
            return x.userId == part.userId;
          });
          return !!partAux;
        }.bind(this)
      );

      var self = this;
      _riders.forEach(function(x) {
        _part_add_news.find(function(y) {
          if (y == x.userId) _backg = "#f1f1f1";
        });

        var partFind = self.registrationObj.participants.find(function(el) {
          return el.userId == x.userId;
        });
        if (!partFind) {
          self.registrationObj.participants.push({
            selected: false,
            disabled: false,
            disabledLimit: false,
            userId: x.userId,
            lName: x.lName,
            fName: x.fName,
            image: self.defaultImage,
            imagenUrl: '',
            relationship: x.relationship,
            status: "",
            membership: "",
            membershipColor: false,
            waivers: "",
            waiversColor: false,
            classes: "",
            classesColor: false,
            backg: _backg,
            emergencyContact: "",
            vehicle: "",
            vehicleColor: false,
            sponsor: "",
            sponsorColor: false,
            birthday: x.birthday,
            email: x.email,
            gender: x.gender,
            existingMembershipEventIds: []
          });
        }
      });

      var users = this.registrationObj.participants.map(function(el) {
        return el.userId;
      });

      // Tier 3: Validation, status, emergency, vehicles -- all independent, run in parallel
      var tier3Promises = [
        RegistrationService.validationOrganizationUsers({
          usersId: users,
          orgId: this.itemOrg.id,
        }),
        RegistrationService.verifyOrganizationStatus({
          usersId: users,
          orgId: this.itemOrg.id,
        }),
        EmergencyContactService.getMultipleEmergencyContact({
          usersId: users,
        })
      ];

      if (this.isVehicles) {
        tier3Promises.push(VehicleService.getMultipleVehicle({ usersId: users }));
      }

      var tier3Results = await Promise.all(tier3Promises);

      // Process validationOrganizationUsers
      var validationResp = tier3Results[0];
      if (validationResp.data.success == 1) {
        self.registrationObj.participants.forEach(function(y) {
          y.existingMembershipEventIds = [];
        });

        if (validationResp.data.message.length > 0) {
          validationResp.data.message.forEach(function(x) {
            self.registrationObj.participants.forEach(function(y) {
              if (y.userId == x.userId) {
                if (self.isEventSpecificMembership(x.periodType)) {
                  const membershipEventId = Number(x.membershipEventId);
                  if (Number.isFinite(membershipEventId) && membershipEventId > 0 && !y.existingMembershipEventIds.includes(membershipEventId)) {
                    y.existingMembershipEventIds.push(membershipEventId);
                  }
                } else {
                  y.disabled = true;
                }
              }
            });
          });
        }
      }
      this.loadingPart.validationUser = true;

      // Process verifyOrganizationStatus
      var statusResp = tier3Results[1];
      if (statusResp.data.success) {
        var states = statusResp.data.message;
        this.registrationObj.participants.forEach(function(el) {
          var find = states.find(function(el1) {
            return el1.userId == el.userId;
          });
          el.hasMembership = false;
          if (
            find.status != "" &&
            find.status != "invalid_age" &&
            find.status != "deleted" &&
            find.status != "failed" &&
            !find.expired
          ) {
            el.disabledStatus = false;
            if (find.periodType == 4) {
              el.status = self.$t("membershipRegistration.yearly_member");
              el.hasMembership = true;
              el.disabledStatus = true;
            } else if (find.periodType == 5) {
              el.status = self.$t("membershipRegistration.lifetime_member");
              el.hasMembership = true;
              el.disabledStatus = true;
            } else if (find.periodType == 1) {
              el.status = self.$t("membershipRegistration.temporary_member");
              el.hasMembership = !self.isEventSpecificMembership(find.periodType);
              el.disabledStatus = false;
            } else {
              el.status = self.$t("membershipRegistration.not_member");
              el.disabled = false;
            }
          } else if (find.status == "invalid_age") {
            el.status = self.$t("membershipRegistration.invalid_age");
            el.disabledStatus = true;
          } else if (find.expired) {
            el.status = self.$t("membershipRegistration.membership_expired");
            el.disabled = false;
            el.disabledStatus = false;
          } else {
            el.status = self.$t("membershipRegistration.not_member");
            el.disabled = false;
            el.disabledStatus = false;
          }
        });
      }
      this.loadingPart.verifyStatus = true;

      // Process getMultipleEmergencyContact
      var emergencyResp = tier3Results[2];
      if (emergencyResp.data.success == 1) {
        if (emergencyResp.data.message.length > 0) {
          emergencyResp.data.message.forEach(function(x) {
            self.registrationObj.participants.forEach(function(y) {
              if (y.userId == x.userId) {
                if (x.count > 0) {
                  y.emergencyContact = 1;
                } else {
                  y.disabled = true;
                  y.emergencyContact = 0;
                }
              }
            });
          });
        }
      }
      this.loadingPart.getEmergencyContact = true;

      // Process getMultipleVehicle
      if (this.isVehicles) {
        var vehicleResp = tier3Results[3];
        if (vehicleResp.data.success == 1) {
          if (vehicleResp.data.message.length > 0) {
            vehicleResp.data.message.forEach(function(x) {
              self.registrationObj.participants.forEach(function(y) {
                if (y.userId == x.userId) {
                  if (x.count > 0) {
                    y.vehicle = "";
                    y.vehicleColor = false;
                  } else {
                    y.disabled = true;
                    y.vehicle = self.$t(
                      "membershipRegistration.vehicle_required"
                    );
                    y.vehicleColor = true;
                  }
                }
              });
            });
          }
        }
        this.loadingPart.getVehicle = true;
      } else {
        this.loadingPart.getVehicle = true;
      }
    },
    showSnackBar(msg, color) {
      this.snackbar = true;
      this.msg_snackbar = msg;
      this.color_snackbar = color;
      setTimeout(() => (this.snackbar = false), 3000);
    },
    breadCrumbStep1() {
      this.inProcess = false;
      this.step = 1;
    },
    async uploadCropperImage(data) {
      const { userId, imagenUrl, fName, lName } = data;
      const base64Data = imagenUrl.replace(/^data:image\/\w+;base64,/, "");
      const byteCharacters = atob(base64Data);
      const byteArray = new Uint8Array(byteCharacters.length);      
      for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([byteArray], { type: 'image/png' });
      let fileName = `${userId}_${fName}_${lName}.png`;      
      const file = new File([blob], fileName, { type: 'image/png' });
      return file;
    },    
    async getTransactionSummary() {
      const data = {
        membershipTypeId: this.membershipTypeId,
        organizationId: this.organizationId,
        membershipEventId: this.dailyEventId,
        feedback: this.feedback,
        selections: [],
        selectionsExtraItems: []
      };
      
      const _userId = this.userId;

      // Filter selected extra items
      const selectedItems = this.registrationObj.extraItems.flatMap(section => 
          section.items.filter(item => item.selected)
      );
      
      data.selectionsExtraItems = selectedItems;
      for (const participant of this.selectedParticipants) {

        if (participant.selections) {
          for (const selection of participant.selections) {
            data.selections.push({
              userId: participant.userId,
              registeredBy: _userId,
              group: selection.class.organizationClassesId,
              class: selection.class.id,
              raceNumber: selection.raceNumber,
              membershipEventId: participant.membershipEventId || this.dailyEventId,
              organizationTeamId: participant.organizationTeamId || null,
              associatedMemberId: participant.associatedMemberId || null,
              relationCodeId: participant.relationCodeId || null
          });
        }
        } else {
          data.selections.push({
              userId: participant.userId,
              registeredBy: _userId,
              group: '',
              class: '',
              raceNumber: '',
              membershipEventId: participant.membershipEventId || this.dailyEventId,
              organizationTeamId: participant.organizationTeamId || null,
              associatedMemberId: participant.associatedMemberId || null,
              relationCodeId: participant.relationCodeId || null
          });
        }
      }


      this.$refs.transactionSummary.loading = true;
      await APIService.fetch({
        method: "post",
        data,
        path: `${this.urlDomain}/laravel/public/api/v1/participant/membership/member-registration/get-transaction-summary`
      }).then(async (resp) => {
        if (resp.data.success) {
          const message = resp.data.message;
          for (const participant of this.selectedParticipants) {
            if (this.isHeadshotRequired) {
              try {
                const file = await this.uploadCropperImage(participant);

                const formData = new FormData();
                formData.append('image', file);
                formData.append('userId', participant.userId);
                formData.append('fileName', `${participant.userId}_${participant.fName}_${participant.lName}_${message.regid}.png`);
                formData.append('regid', message.regid);

                const axiosConfig = { headers: { "content-type": "multipart/form-data" } };

                await axios.put(
                  `${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/register/organization/updateHeadShot/`,
                  formData,
                  axiosConfig
                );

              } catch (error) {
                this.showSnackBar('unexpectedError', 'error');
              }
            }
          }
          this.$refs.transactionSummary.Initialize(message);
        } else {
          const message = Array.isArray(resp.data.message) ? resp.data.message[0] : resp.data.message;
          this.$refs.transactionSummary.loading = false;
          this.showSnackBar(this.membershipRegistrationErrorMessage(message), 'error');
        }
      }); 
    },
    isEventSpecificMembership(periodType) {
      return Number(periodType) === 1;
    },
    membershipRegistrationErrorMessage(message) {
      const messages = {
        event_id_required: "memberRegistration.step3.content.event_id_required",
        membership_already_exists: "membership.error_duplicate",
      };
      return this.$t(messages[message] || "membershipRegistration.failed_save");
    },
    async getRegistrationCards()
    {
      this.passportLoading = true;
      this.$emit("changeLoadingStep", true);
      try {
        const resp = await APIService.fetch({
          method: "get",
          path: `${this.urlDomain}/laravel/public/api/v1/participant/membership/member-registration/get-registration-cards/${this.token}`,
        });
        if (resp.data.success)
        {
          this.passport.registrationCards = resp.data.message.registrationCards;
        }
      } finally {
        this.passportLoading = false;
        this.$emit("changeLoadingStep", false);
      }
    },
    async getOrganizationWaiverSigned()
    {
      if (!this.organizationId || this.selectedParticipantsId.length === 0) {
        this.resetOrganizationWaiverState();
        return [];
      }
      const data = {
        organizationId: this.organizationId,
        participants: this.selectedParticipantsId,
        lc: this.langCode,
        ipAddress: this.currentIp,
        membershipTypeId: this.membershipType ? this.membershipType.id : null,
        membershipTypeName: this.membershipType ? this.membershipType.Name : "",
        membershipStartDate: this.membershipType ? this.membershipType.preRegFrom : null,
        membershipEndDate: this.membershipType ? this.membershipType.dateTo : null,
        isAllDocuments: true
      };

      try {
        this.loadingOrganizationWaivers = true;
        const resp = await APIService.fetch({
          method: "post",
          path: `${this.urlDomain}/laravel/public/api/v1/participant/organization/waiver/signed`,
          data
        });
        if (resp.data.success)
        {
          let waivers = Array.isArray(resp.data.message) ? resp.data.message : [];
          const pendingWaivers = waivers.filter((waiver) => this.isOrganizationWaiverPending(waiver));
          this.organizationWaivers = waivers;
          this.numWaiversToSign = pendingWaivers.length;
          this.hasWaiversToSign = waivers.length > 0;
          await this.syncOrganizationWaiversStep();
          return waivers;
        }
      } catch (error) {
        return null;
      } finally {
        this.loadingOrganizationWaivers = false;
      }
      return [];
    },
    reloadstep() {
      this.$emit("changeLoadingStep", true);
      this.forceStep = true;
      this.token = null;
      this.step = 1;
      this.resetOrganizationWaiverState();
      this.registrationObj = { participants: [], extraItems: [] };
      localStorage.removeItem('member_reg');
      this.initializeUser();
    },
  },
  watch: {
    language(val) {
      if (this.onLoad && val.languageId)
        document
          .getElementById("membershipReg")
          .contentWindow.updateLang(val.languageId);
    },
    step(val){
      if(!val) return;
      switch (val) {
        case 3.06:
          if (this.organizationWaivers.length > 0) {
            this.syncOrganizationWaiversStep();
          } else {
            this.getOrganizationWaiverSigned();
          }
          break;

        case 7:
          this.getTransactionSummary();
          break;

        case 8:
          this.getRegistrationCards();
          break;
      }
    },
    filteredOrganizations(filteredOrganizations)
    {
      if(this.forceStep) {
        return;
      }
      if (!filteredOrganizations || !Array.isArray(filteredOrganizations) || filteredOrganizations.length == 0)
      {
        return;
      }

      if (this.bPreselectedOrganization)
      {
        this.bPreselectedOrganization = false;

        let targetOrganization = filteredOrganizations.find(o => o.id == this.preselectedOrganizationId);
        if (!targetOrganization)
        {
          return;
        }

        this.nextStepOrg(targetOrganization);
      }
    },
    '$route'(to) {
      if(to.name == 'MemberRegistration') {
        this.refresStep();
      }
    },
    panelMembershipTypes(value) {
      this.loadPricesOptionalItemsForPanel(value);
    },
    membershipTypes() {
    }
  },
  beforeDestroy() {
    this.$emit("changeLoadMarginTop", true);
  },
};
</script>

<style lang="scss">
#memberRegistration {
  .btn_next {
    color: white !important;
  }

  #cont_steps .grayC {
    background: #ccc;
  }

  .text-danger {
    color: #a94442;
  }

  .text-warning {
    color: rgb(236, 178, 91);
  }

  .v-stepper__step__step {
    min-width: 28px;
    width: auto;
    padding: 0 6px;
    font-size: 11px;
  }

  @media only screen and (max-width: 1665px) {
    .v-stepper__label {
      display: none;
    }
  }
  @media only screen and (max-width: 1200px) {
    .v-stepper__label {
      display: none;
      font-size: 14px;
      margin-left: 4px;
    }
  }
  .v-stepper__step--active{
    .v-stepper__label {
      display: inline !important;
    }
  }

  .billingDetails {
    width: 100%;
    border-collapse: collapse;
    margin-top: 8px;
    table-layout: fixed;
  }

  .billingDetails td {
    padding: 6px 0;
    vertical-align: top;
  }

  .billingDetails td:first-child {
    padding-right: 16px;
  }

  .billingDetails .orgprice {
    width: 180px;
    text-align: right;
    white-space: nowrap;
  }

  .membership-validity-block {
    padding-top: 4px;
    padding-bottom: 0;
  }

  .membership-meta-block {
    color: #354052;
  }

  .membership-meta-block p {
    margin-bottom: 6px;
  }

  .membership-meta-label {
    font-weight: 600;
    margin-right: 6px;
  }

  .membership-validity-title {
    color: #d50000;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 2px;
  }

  .membership-validity-note {
    margin-bottom: 8px;
    font-size: 16px;
  }

  .membership-pricing-table {
    margin-top: 8px;
  }

  .pricing-preview-card {
    background: #f1f1f1;
    border-radius: 6px;
    padding: 14px 16px;
  }

  .membership-total-row h3 {
    margin-bottom: 0;
    font-weight: 700;
    font-size: 22px;
  }

  .membership-pricing-note {
    margin: 8px 0 0;
    font-size: 16px;
  }

  .org-unavailable-message {
    background: #e8f4fd;
    border-left: 4px solid #2196f3;
    color: #0c3c60;
    border-radius: 4px;
  }
}
</style>
